







































































































import { Component, Vue } from "vue-property-decorator";
import { actorModule } from "../../store/actor";
import ApolloClient, { serverBase } from "../../apollo";
import gql from "graphql-tag";
import IActor from "../../types/actor";
import moment from "moment";
import CustomFieldSelector from "../CustomFieldSelector.vue";
import countries from "../../util/countries";

@Component({
  components: {
    CustomFieldSelector
  }
})
export default class ActorToolbar extends Vue {
  validEdit = false;
  editDialog = false;
  editName = "";
  editAliases = [] as string[];
  editBirthDate = null as number | null;
  editDescription = "";
  editNationality = null as string | null;

  actorNameRules = [v => (!!v && !!v.length) || "Invalid actor name"];

  removeDialog = false;
  removeLoader = false;

  get countries() {
    return countries;
  }

  remove() {
    if (!this.currentActor) return;

    this.removeLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeActors(ids: $ids)
        }
      `,
      variables: {
        ids: [this.currentActor._id]
      }
    })
      .then(res => {
        this.removeDialog = false;
        this.$router.replace("/actors");
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.removeLoader = false;
      });
  }

  openRemoveDialog() {
    this.removeDialog = true;
  }

  async sleep(ms: number) {
    return new Promise(r => setTimeout(r, ms));
  }

  async editActor() {
    if (!this.currentActor) return;

    await this.sleep(50);

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            name
            nationality {
              name
              alpha2
              nationality
            }
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          name: this.editName,
          description: this.editDescription,
          aliases: this.editAliases,
          bornOn: this.editBirthDate,
          nationality: this.editNationality
        }
      }
    })
      .then(res => {
        actorModule.setName(this.editName.trim());
        actorModule.setDescription(this.editDescription.trim());
        actorModule.setAliases(this.editAliases);
        actorModule.setBornOn(this.editBirthDate);
        actorModule.setNationality(res.data.updateActors[0].nationality);
        this.editDialog = false;
      })
      .catch(err => {
        console.error(err);
      });
  }

  openEditDialog() {
    if (!this.currentActor) return;
    this.editName = this.currentActor.name;
    this.editAliases = this.currentActor.aliases;
    this.editDialog = true;
    this.editBirthDate = this.currentActor.bornOn;
    this.editDescription = this.currentActor.description || "";
    this.editNationality = this.currentActor.nationality
      ? this.currentActor.nationality.alpha2
      : null;
  }

  favorite() {
    if (!this.currentActor) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            favorite
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          favorite: !this.currentActor.favorite
        }
      }
    })
      .then(res => {
        actorModule.setFavorite(res.data.updateActors[0].favorite);
      })
      .catch(err => {
        console.error(err);
      });
  }

  bookmark() {
    if (!this.currentActor) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            bookmark
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          bookmark: this.currentActor.bookmark ? null : Date.now()
        }
      }
    })
      .then(res => {
        actorModule.setBookmark(res.data.updateActors[0].bookmark);
      })
      .catch(err => {
        console.error(err);
      });
  }

  get currentActor() {
    return actorModule.current;
  }

  mounted() {
    /* window.addEventListener("keydown", ev => {
      if (ev.keyCode === 70) {
        this.favorite();
      } else if (ev.keyCode === 66) {
        this.bookmark();
      }
    }); */
  }
}
